import { render, staticRenderFns } from "./SalesBySalesChannel.vue?vue&type=template&id=12a99630"
import script from "./SalesBySalesChannel.vue?vue&type=script&lang=js"
export * from "./SalesBySalesChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports